<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="currentTab" :stepTitle="stepTitle"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <!-- <PublishHelper></PublishHelper> -->
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">价格日历</span>
              <span class="card-txt">
                <span v-if="catalogId==1">票型名称</span>
                <span v-if="catalogId==2">房型名称</span>
                <span v-else>套餐名称</span>：
                {{ optionName }}</span>
            </a-col>
          </a-row>
          <a-row :span="24">
            <a-col :span="15" style="position: relative">
              <!-- :disabledDate="disabledDate" -->
              <div v-if="catalogId==2&&planPriceList&&planPriceList.length>0">
                <a-tabs type="card" v-model="ratePlanId" @change="callPlanPriceBack" style="max-width: 1072px;">
                  <a-tab-pane v-for="item in planPriceList" :key="item.ratePlanId"
                              :tab="item.ratePlanName"></a-tab-pane>
                </a-tabs>
              </div>
              <a-calendar :mode="mode" @panelChange="onPanelChange" @select="onDateSelected"
                          :disabledDate="disabledDate">
                <div style="width: 100%;" slot="dateCellRender" slot-scope="value">
                  <a-checkbox v-if="!isDisabledDate(value)&&!getDisabledDate(value)"
                              class="item-checkbox" :checked="isSelected(value)"
                              style="width: 40px">
                  </a-checkbox>
                  <div v-for="item in getListData(value)" :key="item.content" style="font-size: 12px">
                    {{ item.content }}
                  </div>
                </div>
              </a-calendar>
              <a-checkbox :class="catalogId==2?'pos-top1':'pos-top2'" v-model="selectedAll" :disabled="disabledAll"
                          @change="selectedAllDate">全选
              </a-checkbox>
            </a-col>
            <a-col :span="9" v-if="catalogId==1||catalogId==2||catalogId==4">
              <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{span:11}"
                            :wrapper-col="{span:13}">
                <a-form-model-item label="建议销售价" prop="advicePrice">
                  <a-input v-model="ruleForm.advicePrice" disabled placeholder="请输入"></a-input>
                </a-form-model-item>
                <a-form-model-item label="实际销售价" prop="actualSalePrice">
                  <a-input v-model="ruleForm.actualSalePrice" placeholder="请输入"></a-input>
                </a-form-model-item>
                <a-form-model-item label="分销佣金" prop="commissionPrice">
                  <a-input v-model="ruleForm.commissionPrice" placeholder="请输入"></a-input>
                </a-form-model-item>
                <a-form-model-item label="库存" prop="stock">
                  <a-input v-model="ruleForm.stock" disabled placeholder="请输入库存"></a-input>
                </a-form-model-item>
                <a-form-model-item label="预警" prop="warning">
                  <a-input v-model="ruleForm.warning" disabled placeholder="请输预警值"></a-input>
                </a-form-model-item>
                <div style="text-align: center">
                  <a-button type="primary" :disabled="submitDis" @click="onSubmit" :loading="submitLoading">保存
                  </a-button>
                  <a-button @click="resetForm" :disabled="submitDis" style="margin-left: 10px">重置</a-button>
                </div>
              </a-form-model>
            </a-col>
            <a-col :span="9" v-else>
              <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="{span:5}"
                            :wrapper-col="{span:19}">
                <a-form-model-item label="建议销售价" required class="mb0">
                  <a-form-model-item prop="advicePrice" class="inline mr15">
                    <a-input v-model="ruleForm.advicePrice" disabled placeholder="成人建议销售价"></a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="adviceChildPrice" class="inline">
                    <a-input v-model="ruleForm.adviceChildPrice" disabled placeholder="儿童建议销售价"></a-input>
                  </a-form-model-item>
                </a-form-model-item>
                <a-form-model-item label="实际销售价" required class="mb0">
                  <a-form-model-item prop="actualSalePrice" class="inline mr15">
                    <a-input v-model="ruleForm.actualSalePrice" placeholder="成人实际销售价"></a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="actualChildSalePrice" class="inline">
                    <a-input v-model="ruleForm.actualChildSalePrice" placeholder="儿童实际销售价"></a-input>
                  </a-form-model-item>
                </a-form-model-item>
                <a-form-model-item label="分销佣金" class="mb0">
                  <a-form-model-item prop="commissionPrice" class="inline mr15">
                    <a-input v-model="ruleForm.commissionPrice" placeholder="请输入成人佣金"></a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="commissionChildPrice" class="inline">
                    <a-input v-model="ruleForm.commissionChildPrice" placeholder="请输入儿童佣金"></a-input>
                  </a-form-model-item>
                </a-form-model-item>
                <a-form-model-item label="库存" prop="stock">
                  <a-input v-model="ruleForm.stock" disabled placeholder="请输入库存"></a-input>
                </a-form-model-item>
                <a-form-model-item label="预警" prop="warning">
                  <a-input v-model="ruleForm.warning" disabled placeholder="请输预警值"></a-input>
                </a-form-model-item>
                <div style="text-align: center">
                  <a-button type="primary" :disabled="submitDis" @click="onSubmit" :loading="submitLoading">保存
                  </a-button>
                  <a-button @click="resetForm" :disabled="submitDis" style="margin-left: 10px">重置</a-button>
                </div>
              </a-form-model>
            </a-col>
          </a-row>
        </a-card>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from './ProductHeader'
import PublishHelper from './PublishHelper'
import moment from 'moment'

export default {
  name: 'ProNoOwnPrice',
  components: {
    ProductHeader,
    PublishHelper
  },
  data() {
    var checkActualSalePrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.advicePrice)) {
          callback(new Error('须大于或等于建议销售价'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkActualChildSalePrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.adviceChildPrice)) {
          callback(new Error('须大于或等于建议销售价'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      moment,
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      optionId: this.$route.query.optionId,
      ratePlanId: Number(this.$route.query.ratePlanId),
      optionName: this.$route.query.optionName,
      ruleForm: {
        adviceChildPrice: '', //建议销售儿童价
        advicePrice: '', //建议销售价;建议销售成人价
        commissionPrice: '', //佣金
        commissionChildPrice: '', //儿童价佣金
        dates: '', //日期
        merchantId: 0, //商户Id
        optionId: this.$route.query.optionId, //
        proId: this.$route.query.proId,
        ratePlanId: this.$route.query.ratePlanId,
        stock: '', //库存
        warning: '', //警告
        actualChildSalePrice: '', //实际销售儿童价 ,
        actualSalePrice: '' //实际销售价;实际销售成人价 ,
      },
      submitLoading: false,
      submitFormData: '',
      submitDis: false,
      rules: {
        actualSalePrice: [
          { required: true, message: '请输入实际销售价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          },
          { validator: checkActualSalePrice, trigger: 'blur' }
        ],
        actualChildSalePrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkActualChildSalePrice, trigger: 'blur' }
        ],
        commissionPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ],
        commissionChildPrice: [
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' }
        ]
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      mode: 'month',
      selectedAll: false,
      priceDataList: [],
      selectedDateList: [],
      monthStr: '',
      stepTitle: '',
      currentTab: 1.4,
      planPriceList: [],
      disabledAll: false
    }
  },
  mounted() {
    this.monthStr = this.getDateHelper().getCurrentFormatDate('YYYY-MM')
    this.currentTab = (this.catalogId == 73 || this.catalogId == 74) ? 3.1 : 1.4
    this.getProPriceInfo()
    if (this.catalogId == 1) {
      this.stepTitle = '票型及价格'
    } else if (this.catalogId == 2) {
      this.stepTitle = '房型/价格计划'
      this.getPlanPriceList()
    } else if (this.catalogId == 4) {
      this.stepTitle = '套餐及价格'
    } else if (this.catalogId == 75) {
      this.stepTitle = '图文详情及价格'
    } else {
      this.stepTitle = '套餐/价格/库存'
    }
  },
  watch: {
    selectedDateList: function(dateList) {
      if (dateList && dateList.length > 0) {
        //自动填充选中的第一个日期的价格
        const firstDate = dateList[0]
        this.getLogUtils().logWithTag('==selectedDateList1', firstDate)
        let selectedPriceItem = this.priceDataList.find((item, index, arr) => item.priceDate === firstDate)
        if (selectedPriceItem) {
          this.ruleForm = selectedPriceItem
          this.getLogUtils().logWithTag('==selectedDateList2', this.ruleForm)
        }
      }
    }
  },
  methods: {
    //切换价格计划
    callPlanPriceBack(key) {
      this.getLogUtils().logWithTag('==callPlanPriceBack', key)
      this.ratePlanId = key
      this.getProPriceInfo()
    },
    //获取价格计划列表
    getPlanPriceList() {
      let params = {
        limitDto: {
          pageNum: 1,
          pageSize: 100
        },
        proId: this.$route.query.proId,
        optionId: this.$route.query.optionId
      }
      this.getHttpServices().getProService().post('api/v2/productManage/findRatePlanList', params).then(res => {
        this.getLogUtils().logWithTag('==getPlanPriceList', res)
        this.planPriceList = res.data
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getDisabledDate(current) {
      // this.getLogUtils().logWithTag('==isDisabledDate===',current)
      return current && current < moment().startOf('day')
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    //判断选项是否禁用(非当前月的数据禁用)
    isDisabledDate(value) {
      const dateStr = this.getDateHelper().formatDate(value, 'YYYY-MM')
      return dateStr !== this.monthStr
    },
    getListData(value) {
      let listData = []
      const dateStr = this.getDateHelper().getFormatDate(value)
      const priceItem = this.priceDataList.find((item, index, arr) => item.priceDate === dateStr)
      if (this.catalogId == 1 || this.catalogId == 2 || this.catalogId == 4) {
        if (priceItem) {
          if (priceItem.advicePrice) {
            listData.push({ type: 'success', content: '销售价    ¥' + priceItem.advicePrice })
          }
          if (priceItem.actualSalePrice) {
            listData.push({ type: 'success', content: '实际销售价    ¥' + priceItem.actualSalePrice })
          }
          if (priceItem.purchasePrice) {
            listData.push({ type: 'success', content: '采购价    ¥' + priceItem.purchasePrice })
          }
          if (priceItem.stock) {
            listData.push({ type: 'success', content: '库存    ' + priceItem.stock })
          }
          if (priceItem.warning) {
            listData.push({ type: 'success', content: '预警值    ' + priceItem.warning })
          }
        }
      } else {
        if (priceItem) {
          if (priceItem.advicePrice) {
            listData.push({ type: 'success', content: '成人建议销售价¥' + priceItem.advicePrice })
          }
          if (priceItem.adviceChildPrice) {
            listData.push({ type: 'success', content: '儿童建议销售价¥' + priceItem.adviceChildPrice })
          }
          if (priceItem.actualSalePrice) {
            listData.push({ type: 'success', content: '成人实际销售价¥' + priceItem.actualSalePrice })
          }
          if (priceItem.actualChildSalePrice) {
            listData.push({ type: 'success', content: '儿童实际销售价¥' + priceItem.actualChildSalePrice })
          }
          if (priceItem.stock) {
            listData.push({ type: 'success', content: '库存    ' + priceItem.stock })
          }
          if (priceItem.warning) {
            listData.push({ type: 'success', content: '预警值    ' + priceItem.warning })
          }
        }
      }

      return listData
    },
    onDateSelected(date) {
      this.getLogUtils().logWithTag('==onDateSelected mode===', this.mode)
      this.getLogUtils().logWithTag('==onDateSelected date===', date)
      if (this.mode === 'year') {
        this.mode = 'month'
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getProPriceInfo()
      } else {
        const dateStr = this.getDateHelper().getFormatDate(date)
        this.getLogUtils().logWithTag('==onDateSelected dateStr===', dateStr)
        if (this.isSelected(date)) {
          this.selectedDateList = this.selectedDateList.filter((item, index, arr) => dateStr !== item)
        } else {
          this.selectedDateList.push(dateStr)
        }
      }
      this.getLogUtils().logWithTag('==onDateSelected dateStr===', this.selectedDateList)
    },
    isSelected(momentValue) {
      const dateStr = this.getDateHelper().getFormatDate(momentValue)
      const index = this.selectedDateList.findIndex((item, index, arr) => dateStr === item)
      return index >= 0
    },
    onPanelChange(date, mode) {
      this.mode = mode
      this.getLogUtils().logWithTag('===onPanelChange mode===', mode)
      this.getLogUtils().logWithTag('===onPanelChange date===', moment(date).format('YYYY-MM-DD'))
      // const diff = moment(date).diff(moment(moment().startOf('day').toDate()), 'days')
      // this.submitDis = diff<0?true:false;
      // this.getLogUtils().logWithTag('===onPanelChange diff1===',diff)
      if (mode === 'month') {
        this.selectedAll = false
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getLogUtils().logWithTag('===this.monthStr ===', this.monthStr)
        let nowMouth = moment(new Date()).format('YYYY-MM')
        let diffMonths = this.getDateHelper().diffMonths(nowMouth, this.monthStr)
        this.disabledAll = diffMonths >= 0 ? false : true
        this.getProPriceInfo()
      }
    },
    selectedAllDate: function(e) {
      if (e.target.checked) {
        const newList = []
        let days = this.getDateHelper().getDaysInMonth(this.monthStr + '-01')
        for (let i = 1; i <= days; i++) {
          newList.push(this.monthStr + '-' + (i > 9 ? i : '0' + i))
        }
        let nowDate = moment(new Date()).format('YYYY-MM-DD')
        this.getLogUtils().logWithTag('===selectedAllDate nowDate===', nowDate)
        let index = newList.indexOf(nowDate)
        this.getLogUtils().logWithTag('index', index)
        if (index != -1) {
          this.selectedDateList = newList.slice(index, newList.length)
        } else {
          this.selectedDateList = newList
        }
      } else {
        this.selectedDateList = []
      }
      this.selectedAll = e.target.checked
      this.getLogUtils().logWithTag('selectedAllDate', e.target.checked)
      this.getLogUtils().logWithTag('==onDateSelected dateStr===', this.selectedDateList)
    },
    checkForm() {
      if (this.selectedDateList.length < 1) {
        this.$message.error('请选择日期')
        return false
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.submitFormData.dates = this.selectedDateList.join(',')
      this.getHttpServices().getProService().post('priceCalendar/savePriceCalendarNonMySelf', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('价格日历设置成功')
        this.getProPriceInfo()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //获取全月的接口
    getProPriceInfo() {
      this.getHttpServices().getProService().post('priceCalendar/fullMonthPriceNonMySelf', {
        optionId: this.optionId,
        proId: this.proId,
        startDateStr: this.monthStr + '-01',
        ratePlanId: this.ratePlanId
      }).then(res => {
        this.getLogUtils().logWithTag('getProPriceInfo', res)
        this.priceDataList = res.calendarDayNonMySelfVOs
        this.selectedDateList = []
        this.selectedAll = false
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 删除价格信息
    deleteEvent() {
      this.ruleForm.dates = this.selectedDateList.join(',')
      this.getHttpServices().getProService().post('priceCalendar/deletePriceCalendar', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('deleteEvent', res)
        this.$message.success('删除日历成功')
        this.getProPriceInfo()
        this.resetForm()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      flex-grow: 1;
      width: 400px;

      .inline {
        display: inline-block;

        input {
          max-width: 160px;
        }
      }

      .ml15 {
        margin-left: 15px;
      }

      .mr15 {
        margin-right: 5px;
      }

      .mb0 {
        margin-bottom: 0;
      }
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

.pos-top1 {
  position: absolute;
  right: 320px;
  top: 72px;
}

.pos-top2 {
  position: absolute;
  right: 320px;
  top: 16px;
}
</style>
<style lang="less">
.page-box {
  .selected-color {
    background-color: #e6f7ff;
  }

  .ant-card-body {
    padding-top: 1px;
  }

  .item-checkbox {
    position: absolute;
    top: 6px;
  }

  .ant-fullcalendar table {
    height: 100px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
    height: 125px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-content {
    height: 92px;
  }
}
</style>